import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Controller, EffectCoverflow } from "swiper";
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Controller, EffectCoverflow]);

/**
 * Dynamically intialize the `.usp-slider`'s.
 */


 function msInitializeUSPSlider() {
    const slider = document.querySelector(`.usp-slider`);
    if (slider) {
        let options = slider.dataset.sliderOptions;
        options = JSON.parse(options);
        const uspSlider = new Swiper(`.usp-slider`, options);
    }
}

document.addEventListener(
    `DOMContentLoaded`,
    function () {
        msInitializeUSPSlider();
    },
    { passive: true }
);

